import { Divisor } from './Divisor';
import { InformationOne } from './InformationOne';
import { InformationTwo } from './InformationTwo';
import '../../styles/Information.css';

export const Information = ({project}) => {
    return (
        <div className="sl-information">
            <div className="sl-information-small">
                <InformationOne project={project} />
                <Divisor />
                <InformationTwo project={project}/>
            </div>
        </div>
    );
};
